import Footer from 'layout/footer';
import Header from 'layout/header';
import { Fragment } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const HelpCenterEng = () => {

    return (
            <Fragment>
           <Card.Header as="h5">Help Center</Card.Header>
                                    <Card.Body className='p-4'>
                                        <div>
                                            <p><b>Last Updated: [30 April 2025]</b></p>
                                            <p>Welcome to  <strong>Lorem Ipsum Portal.</strong> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla vitae elit libero, a pharetra augue.</p>

                                            <p><strong>1. Introduction</strong><br />
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur commodo magna non ante imperdiet laoreet. Vivamus non eros at lorem placerat accumsan.</p>

                                            <p><strong>2. Modifications</strong><br />
                                                Integer tincidunt massa in tincidunt vehicula. Suspendisse vehicula, sapien ac iaculis hendrerit, augue risus iaculis felis, eget luctus arcu diam ac neque.</p>

                                            <p><strong>3. Service Overview</strong><br />
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam sed risus at nunc sodales suscipit. Integer cursus varius turpis in commodo.</p>

                                            <p><strong>4. User Registration</strong><br />
                                                Nunc rutrum diam euismod, consequat erat vel, tempus purus. Suspendisse potenti. Morbi efficitur libero in magna feugiat, in tincidunt sapien vestibulum.</p>

                                            <p><strong>5. Usage Guidelines</strong><br />
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin eget tortor a metus tincidunt egestas. Prohibited activities include, but are not limited to:</p>
                                                                <ul style={{marginLeft: '1rem' }}>
                                                <li> • Lorem ipsum dolor sit amet.</li>
                                                <li> • Consectetur adipiscing elit.</li>
                                                <li> • Integer nec odio. Praesent libero.</li>
                                            </ul> <br />
                                            <p><strong>6. Intellectual Property</strong><br />
                                                Quisque accumsan sem nec ligula vestibulum, in scelerisque tortor porttitor.<br />
                                                <br /> Sed vitae mi at augue sagittis ultrices. Nulla ac tristique magna, a posuere lacus.</p>

                                            <p><strong>7. Third-Party Tools</strong><br />
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce porta blandit ex, a tincidunt lorem mattis in.<br />
                                               <br /> Sed eget risus sed enim sollicitudin hendrerit nec in eros.</p>

                                            <p><strong>8. Data Policy</strong><br />
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam gravida efficitur ipsum. Nullam nec tortor vehicula, fermentum ex a, facilisis orci.</p>

                                            <p><strong>9. Payments</strong><br />
                                                Aliquam erat volutpat. Nullam fermentum orci in lectus gravida, sed vestibulum sapien bibendum. Maecenas pulvinar risus sed tortor vulputate, vitae porttitor massa.</p>

                                            <p><strong>10. Account Termination</strong><br />
                                                Sed sed velit facilisis, vestibulum nulla ac, porttitor metus.<br />
                                              <br />  In nec magna at orci porta dictum non ut erat. Nullam pretium ex sed massa gravida, a vestibulum magna hendrerit.</p>

                                            <p><strong>11. No Warranties</strong><br />
                                                Suspendisse vel sem quis leo egestas vulputate. Cras convallis velit a tellus accumsan, a tempus lorem eleifend. Fusce bibendum pretium feugiat.</p>

                                            <p><strong>12. Limitation of Liability</strong><br />
                                                Curabitur eu ante sed dolor sollicitudin porta. In at lectus eget libero ornare commodo. Quisque posuere turpis ut sem lacinia finibus.</p>

                                            <p><strong>13. Indemnity</strong><br />
                                                Nulla a tincidunt nunc, non dapibus lacus. Curabitur a purus et sem scelerisque imperdiet. Aliquam erat volutpat.</p>

                                            <p><strong>14. Legal Jurisdiction</strong><br />
                                                Etiam nec purus a arcu convallis lacinia. Mauris faucibus neque sit amet purus commodo, in mattis tortor tempor.</p>

                                            <p><strong>15. Unforeseen Events</strong><br />
                                                Cras rhoncus massa id tellus fermentum, at porta nunc dapibus. Sed congue bibendum elit, at malesuada orci dictum in.</p>

                                            <p><strong>16. Clause Validity</strong><br />
                                                Nulla at dui rutrum, porta nunc at, scelerisque sapien. Donec viverra semper neque, sed mattis ante tincidunt non.</p>

                                            <p><strong>17. Binding Terms</strong><br />
                                                In ut libero porttitor, commodo magna nec, imperdiet ipsum. Curabitur facilisis, enim nec sagittis blandit, elit erat fringilla justo, at tristique nulla orci nec nulla.</p>

                                            <p><strong>18. Support</strong><br />
                                                If you have questions, reach out to us at: <br /> <br />
                                                <strong>Lorem Ipsum Support</strong><br />
                                                [Email Address]: support@example.com <br />
                                                [Phone Number]: 123-456-7890</p>

                                            <p><strong>By accessing the Lorem Ipsum Portal, you accept these terms. Thank you!</strong></p>
                                        </div>

                                    </Card.Body>
                                
                </Fragment>
    );
};

export default HelpCenterEng;
